import { render, staticRenderFns } from "./ModelMyAccount.vue?vue&type=template&id=d720b8d8&"
import script from "./ModelMyAccount.vue?vue&type=script&lang=js&"
export * from "./ModelMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports